import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { HOTELS_MAX_GUEST_IN_RESERVATION } from "@lib/constants";
import { getTotalGuestsQtyFromHotelOccupationArray } from "@lib/util/hotels/search-ops";
import IconButton from "@modules/shared/components/buttons/icon-button";
import MuscleQuantityTogglerInput from "@modules/shared/components/quantity-toggler-input";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import { GenericSelectInput } from "@modules/shared/components/generic-select-input";
export const OccupationInput = _ref => {
  let {
    index,
    updateThisOccupation,
    occupation,
    removeThisOccupation,
    otherOccupations
  } = _ref;
  const t = useTranslations("Hotels");
  const totalGuestsInOtherOccupations = getTotalGuestsQtyFromHotelOccupationArray(otherOccupations);
  const renderChildrenAgesInputs = () => {
    return occupation.children_ages.map((age, ageIndex) => __jsx(GenericSelectInput, {
      key: ageIndex,
      label: t("InputsBar.CHILD_AGE", {
        count: ageIndex + 1
      }),
      value: age !== null ? age : undefined,
      options: Array.from({
        length: 18
      }, (_, i) => ({
        key: i.toString(),
        value: i
      })),
      placeholder: "",
      onSelect: selectedValue => setChildrenAgeAtIndex(ageIndex, selectedValue)
    }));
  };
  const setChildrenAgeAtIndex = (ageIndex, age) => {
    const newChildrenAges = [...occupation.children_ages];
    newChildrenAges[ageIndex] = age;
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children_ages: newChildrenAges
    }));
  };
  const incrementChildren = () => {
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children: occupation.children + 1,
      children_ages: [...occupation.children_ages, null]
    }));
  };
  const decrementChildren = () => {
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children: occupation.children - 1,
      children_ages: occupation.children_ages.slice(0, -1)
    }));
  };
  return __jsx("div", {
    className: "flex flex-col gap-4 p-4 rounded-lg"
  }, __jsx("div", {
    className: "flex flex-row gap-4 items-center justify-between text-primary_text"
  }, __jsx("p", {
    className: " tx-plg-semiBold md:tx-pmd-semiBold"
  }, "".concat(t("ROOM"), " ").concat(index + 1)), index > 0 && __jsx("div", {
    onClick: e => {
      e.stopPropagation();
      removeThisOccupation();
    }
  }, __jsx(IconButton, {
    icon: __jsx(Icons.circleX, {
      size: 15
    }),
    onClickButton: removeThisOccupation
  }))), __jsx(MuscleQuantityTogglerInput, {
    dataTestId: "guest-selection-adults-room-".concat(index),
    label: t("GuestType.ADULTS"),
    description: t("GuestType.ADULTS_DESCRIPTION"),
    value: occupation.adults,
    onIncrement: () => updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      adults: occupation.adults + 1
    })),
    onDecrement: () => updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      adults: occupation.adults - 1
    })),
    incrementDisabled: HOTELS_MAX_GUEST_IN_RESERVATION - (totalGuestsInOtherOccupations + occupation.children) <= occupation.adults,
    decrementDisabled: occupation.adults <= 1
  }), __jsx(MuscleQuantityTogglerInput, {
    dataTestId: "guest-selection-children-room-".concat(index),
    label: t("GuestType.CHILDREN"),
    description: t("GuestType.CHILDREN_DESCRIPTION"),
    value: occupation.children,
    onIncrement: incrementChildren,
    onDecrement: decrementChildren,
    incrementDisabled: HOTELS_MAX_GUEST_IN_RESERVATION - (totalGuestsInOtherOccupations + occupation.adults) <= occupation.children,
    decrementDisabled: occupation.children === 0
  }), occupation.children > 0 && __jsx("div", {
    className: "space-y-2"
  }, __jsx("div", {
    className: "flex flex-wrap gap-2"
  }, renderChildrenAgesInputs())));
};